<template>
<div class="chapter">
<div class="inner_page">
<p class="p9"><span class="t4">For my mother, Betty,</span></p>
<p class="p0"><span class="t4">for all the excitement and encouragement</span></p>
<p class="p0"><span class="t4">she’s shown for my writing.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005.vue?01432e2c